module.exports = __webpack_public_path__ + "img/visa_icon.44293a29.svg";